import { RootState } from "../root.reducer";

export const filterSelector = (state: RootState) => state.filters;
